export default __webpack_public_path__ + "static/media/hero_anchor_b.a2f210ab.png";